import { render, staticRenderFns } from "./BottomBarPayment.vue?vue&type=template&id=58ead4ef&scoped=true&"
import script from "./BottomBarPayment.vue?vue&type=script&lang=js&"
export * from "./BottomBarPayment.vue?vue&type=script&lang=js&"
import style0 from "./BottomBarPayment.vue?vue&type=style&index=0&id=58ead4ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ead4ef",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
